import { actions, paths } from "../../../../common/constants";

export default {
  login: (credentials) => ({
    [actions.CALL_API]: {
      types: [
        actions.ADMIN_LOGIN_REQUEST,
        actions.ADMIN_LOGIN_SUCCESS,
        actions.ADMIN_LOGIN_FAILURE,
      ],
      promise: (client) => client.post(paths.api.v1.ADMIN_LOGIN, credentials),
    },
  }),

  logout: () => ({
    [actions.CALL_API]: {
      types: [
        actions.ADMIN_LOGOUT_REQUEST,
        actions.ADMIN_LOGOUT_SUCCESS,
        actions.ADMIN_LOGOUT_FAILURE,
      ],
      promise: (client) => client.get(paths.api.v1.ADMIN_LOGOUT),
    },
  }),

  resetLoginState: () => ({ type: actions.RESET_LOGIN_STATE }),
};



// WEBPACK FOOTER //
// ./client/react/Admin/actions/authentication.js